require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-attention-furloughed-employees.json") })
        }
      }, "path---es-articles-attention-furloughed-employees");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-attention-furloughed-employees!./.cache/json/es-articles-attention-furloughed-employees.json
// module id = 2031
// module chunks = 231608221292675